import React from 'react'

// components
import {
  CRow,
} from '@coreui/react-pro'
import FormTextInput from '../general-input-form/FormTextInput'
import FormTextAreaInput from '../general-input-form/FormTextAreaInput'
import FormSelectInput from '../general-input-form/FormSelectInput'
import FormSwitchInput from '../general-input-form/FormSwitchInput'

const AppForm = ({
  values,
  handleChange,
  errors,
  policyTypeOptions,
  policyType,
  handleSelectPolicyType,
}) => {
  return (
    <>
      <CRow className="mb-4">
        <FormTextInput 
          id='company_policy_name'
          name='company_policy_name'
          colSize='6'
          inputLabel='Company Policy Name'
          className='mb-3'
          placeholder='Enter company policy name...'
          value={values.company_policy_name}
          handleTextInput={handleChange}
          feedbackInvalid={errors.company_policy_name}
          invalid={errors.company_policy_name}
        />
        <FormTextInput 
          id='company_policy_number'
          name='company_policy_number'
          colSize='6'
          inputLabel='Company Policy Number'
          className='mb-3'
          placeholder='Enter company policy number...'
          value={values.company_policy_number}
          handleTextInput={handleChange}
          feedbackInvalid={errors.company_policy_number}
          invalid={errors.company_policy_number}
          disabled={true}
        />
        <FormTextAreaInput
          id='company_policy_description'
          name='company_policy_description'
          colSize='6'
          inputLabel='Company Policy Description'
          className='mb-3'
          placeholder='Enter company policy description...'
          rows='5'
          value={values.company_policy_description}
          handleTextAreaInput={handleChange}
          feedbackInvalid={errors.company_policy_description}
          invalid={errors.company_policy_description}
        />
        <FormSelectInput 
          id='company_policy_type'
          name='company_policy_type'
          colSize='6'
          inputLabel='Policy Type'
          className='mb-3'
          selectOptions={policyTypeOptions}
          value={policyType}
          handleSelectInput={handleSelectPolicyType}
          feedbackInvalid={errors.company_policy_type}
          invalid={errors.company_policy_type}
          disabled={false}
          placeholder='Please select policy type...'
        />
        <FormSwitchInput 
          id='company_policy_is_published'
          name='company_policy_is_published'
          label={values.company_policy_is_published ? 'Published' : 'Draft'}
          colSize='3'
          inputLabel='Status'
          className='mb-3'
          handleSwitch={handleChange}
          value={values.company_policy_is_published}
          invalid={errors?.company_policy_is_published}
        />
      </CRow>
    </>
  )
}

export default AppForm